import {
  Button,
  Col,
  Form,
  Input,
  PageHeader,
  Row,
  notification,
} from "antd";
import { useEffect, useState } from "react";
import { Prompt, useHistory } from "react-router-dom";
import { useAuth } from "../../context/auth";
import IconTutorials from "../../static/icon/IconTutorials";

import SunEditor from 'suneditor-react';
import {
  align,
  font,
  fontColor,
  fontSize,
  formatBlock,
  hiliteColor,
  horizontalRule,
  lineHeight,
  list,
  paragraphStyle,
  table,
  template,
  textStyle,
  image,
  link,
  video
} from 'suneditor/src/plugins';
import 'suneditor/dist/css/suneditor.min.css';
import "suneditor/src/assets/css/suneditor-contents.css";
import { Switch } from "antd";

const GuideSetting = ({ match: { params: { id } } }) => {
  const history = useHistory();
  const { accessToken } = useAuth();

  const [form] = Form.useForm();

  const [change, setChange] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const [editorStateEn, setEditorStateEn] = useState('');
  const [editorStateTh, setEditorStateTh] = useState('');
  const optionEditor = {
    showPathLabel: false,
    minHeight: '20vh',
    placeholder: 'Enter Display Detail here',
    plugins: [align, font, fontColor, fontSize, formatBlock, hiliteColor, horizontalRule, lineHeight, list, paragraphStyle, table, template, textStyle, image, link, video],
    buttonList: [
      ['undo', 'redo'],
      ['font', 'fontSize', 'formatBlock'],
      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'removeFormat'],
      ['fontColor', 'hiliteColor', 'outdent', 'indent', 'align', 'horizontalRule', 'list', 'table'],
      ['link', 'image', 'video'],
    ],
    formats: ['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
    font: ['Arial', 'Georgia', 'Tahoma', 'Trebuchet MS', 'Verdana', 'Prompt', 'Kanit', 'Sarabun', 'Pridi', 'NotoSansThai'],
  };

  useEffect(() => {
    if (id === 'new') return;

    async function getTutorial() {
      const url = new URL('/api/page/' + id, window.location);

      const res = await fetch(url, {
        headers: { 'X-ACCESS-TOKEN': accessToken },
      });
      if (res.ok) {
        const { page } = await res.json();
        form.setFieldsValue(page);
        setEditorStateEn(page.detailEn);
        setEditorStateTh(page.detailTh);
      } else {
        notification["error"]({
          message: "Something went wrong !",
          description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
        });
      }
    }

    setChange(false);
    getTutorial();
  }, [accessToken, form, id]);

  const save = async (values) => {
    setDisabled(true);
    setChange(false);

    values.type = 'guide'
    values.detailEn = editorStateEn;
    values.detailTh = editorStateTh;

    const url = new URL(id === 'new' ? '/api/page' : '/api/page/' + id, window.location);

    const res = await fetch(url, {
      method: id === 'new' ? 'POST' : 'PATCH',
      headers: {
        'X-ACCESS-TOKEN': accessToken,
        'content-type': 'application/json',
      },
      body: JSON.stringify(values),
    });
    if (res.ok) {
      notification["success"]({
        message: "Successfully saved data.",
      });
      history.push({
        pathname: "/guide",
        searchValue: history.location.searchValue,
        pageValue: history.location.pageValue,
      });
    } else {
      notification["error"]({
        message: "Something went wrong !",
        description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
      });
    }

    setDisabled(false);
    setChange(true);
  };

  return (
    <>
      <div className="flex justify-between items-center mt-2">
        <PageHeader
          style={{ padding: 0, width: "100%" }}
          title={
            <span className="flex items-center mt-2">
              <IconTutorials /> &nbsp;&nbsp;Create Tutorials
            </span>
          }
        />
      </div>
      <div className="content">
        <div className="search">
          <Form
            form={form}
            onFinish={save}
            onFieldsChange={() => setChange(true)}
            className="search_inline row mt-3"
            style={{ display: "inline-grid", margin: "auto", width: "80%" }}
          >
            <Row gutter={[48, 16]}>
              <Col span={24}>
                <Form.Item
                  label="Title (EN)"
                  name="titleEn"
                  colon={false}
                  className="mt-2"
                  rules={[
                    {
                      required: true,
                      message: "Title (EN) is required.",
                    }
                  ]}
                >
                  <Input maxLength={100} placeholder="Title (EN)" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="Detail (EN)"
                  name="detailEn"
                  colon={false}
                  className="mt-2"
                  rules={[
                    {
                      required: true,
                      message: "Detail (EN) is required.",
                    }
                  ]}
                >
                  <SunEditor
                    setContents={editorStateEn}
                    onChange={(html) => setEditorStateEn(html)}
                    setOptions={optionEditor}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="Title (TH)"
                  name="titleTh"
                  colon={false}
                  className="mt-2"
                  rules={[
                    {
                      required: true,
                      message: "Title (TH) is required.",
                    }
                  ]}
                >
                  <Input maxLength={100} placeholder="Title (TH)" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="Detail (TH)"
                  name="detailTh"
                  colon={false}
                  className="mt-2"
                  rules={[
                    {
                      required: true,
                      message: "Detail (TH) is required.",
                    }
                  ]}
                >
                  <SunEditor
                    setContents={editorStateTh}
                    onChange={(html) => setEditorStateTh(html)}
                    setOptions={optionEditor}
                  />
                </Form.Item>
              </Col>
              <Col span={24} className="flex space-x-4 justify-end ">
                <Form.Item
                  label=""
                  name="active"
                  colon={false}
                  className="mt-2"
                  valuePropName="checked"
                  initialValue={true}
                >
                  <Switch />
                </Form.Item>
                <span className="font-bold mt-2.5  ">Inactive/Active</span>
              </Col>
            </Row>

            <div className="w-full text-center flex justify-center space-x-4">
              <Button
                className="w-36"
                type="primary"
                ghost
                shape="round"
                htmlType="button"
                onClick={() => {
                  history.push({
                    pathname: "/guide",
                    searchValue: history.location.searchValue,
                    pageValue: history.location.pageValue,
                  });
                }}
              >
                Cancel
              </Button>
              <Button
                className="w-36"
                key="save"
                type="primary"
                shape="round"
                htmlType="submit"
                disabled={disabled}
              >
                Save
              </Button>
            </div>
          </Form>
        </div>
      </div>

      <Prompt when={change} message="Changes will not be saved. Do you want to proceed ?" />
    </>
  );
};
export default GuideSetting;
